import { Link, useNavigate } from "react-router-dom";
import { AssetIdBreakdown } from "../../components/AssetIdBreakdown";
import { siteNameOrPortfolio } from "../../../../common/utils/siteNameOrPortfolio";
import { PATH, setFilters } from "../../../../router-path";
import { Box, IconButton, SxProps, Theme } from "@mui/material";
import { Pricing } from "../../pricingListSlice";
import { If } from "../../../../common/components/If";
import { SiteLogoOrPortfolioLogo } from "../../../../common/components/SiteOrPortfolioLogo";
import EqualizerIcon from "@mui/icons-material/Equalizer";

export interface SiteColumnProps {
	pricing?: Pricing;
	isScrolling?: boolean;
	openGraphModal: (pricing: Pricing | undefined) => void;
	style: SxProps<Theme>;
}

export const SiteColumn = ({
	pricing,
	isScrolling,
	openGraphModal,
	style = {},
}: SiteColumnProps) => {
	const navigate = useNavigate();
	let linkToSite = null;
	if (pricing?.portfolio_id) {
		linkToSite = (
			<AssetIdBreakdown
				title={siteNameOrPortfolio(pricing)}
				breakdown={pricing?.portfolio_asset_id_breakdown}
			/>
		);
	} else {
		const pathname = `${PATH.SITES}?searchValue=${pricing?.site_pricings[0].site.asset_id}`;
		linkToSite = (
			<Link
				to={pathname}
				onClick={(e) => {
					e.preventDefault();
					navigate(
						PATH.SITES,
						setFilters({
							searchValue:
								pricing?.site_pricings[0].site.asset_id,
						})
					);
				}}
			>
				{siteNameOrPortfolio(pricing)}
			</Link>
		);
	}
	return (
		<Box sx={style}>
			<If condition={pricing}>
				<If condition={!isScrolling}>
					<SiteLogoOrPortfolioLogo pricing={pricing} />
					<IconButton aria-label="open-graph" sx={{ height: "24px" }}>
						<EqualizerIcon
							onClick={() => openGraphModal(pricing)}
						/>
					</IconButton>
				</If>
				<If condition={isScrolling}>
					<Box
						sx={{
							height: "24px",
							width: "20px",
							marginRight: "5px",
							borderRadius: "5px",
							backgroundColor: "rgb(87, 87, 87)",
							opacity: 0.8,
						}}
					/>
				</If>
				<Box
					sx={{
						alignSelf: "center",
						textOverflow: "ellipsis",
						overflow: "hidden",
						whiteSpace: "nowrap",
						width: "100%",
					}}
				>
					{linkToSite}
				</Box>
			</If>
		</Box>
	);
};
